export const buildHighRiskSupplementsListPayload = ({ page, selectedCategory }: any) => ({
  pagedResultsRequest: {
    pagination: {
      page,
      pageSize: Number(process.env.REACT_APP_PAGE_SIZE_FOR_USER_INQUIRIES_TABLE) || 10,
    },
    search: '',
    sort: {
      active: '',
      direction: '',
    },
  },
  ...(Boolean(selectedCategory) && { riskSupplementCategoryId: selectedCategory }),
});
